/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { DeadToken } from "../DeadToken";

export class DeadToken__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<DeadToken> {
    return super.deploy(overrides || {}) as Promise<DeadToken>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DeadToken {
    return super.attach(address) as DeadToken;
  }
  connect(signer: Signer): DeadToken__factory {
    return super.connect(signer) as DeadToken__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DeadToken {
    return new Contract(address, _abi, signerOrProvider) as DeadToken;
  }
}

const _abi = [
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60806040526000805460ff19166012179055348015601c57600080fd5b50607c8061002b6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063313ce56714602d575b600080fd5b6000546040805160ff9092168252519081900360200190f3fea2646970667358221220eb60c1a607acd916badadb9e53addd02cad714acc094b694f47d2a6accc8147e64736f6c63430008020033";
